import { useState, useMemo, useEffect, memo } from "react";
import { ITag, INiche } from "@/common/services/types";
import { TagLink } from "./TagLink";
import { PinkBaseButton } from "components/buttons/PinkBaseButton";
import PlusIcon from "@/common/images/icons/plus.svg?react";

import "./styles.scss";

export interface TagListProps {
  tags: (INiche | ITag)[];
  pageSize?: number;
  counts: boolean;
}

export const TagList: React.FC<TagListProps> = memo(({ tags: initialTags, pageSize = 0, counts }) => {
  const [page, setPage] = useState<number>(1);

  const tags = useMemo(() => initialTags.filter(tag => !!tag.name), [initialTags]);
  const paginatedTags = useMemo(() => tags.slice(0, pageSize * page), [tags, page, pageSize]);
  const tagsList = pageSize ? paginatedTags : tags;

  useEffect(() => {
    if (pageSize) {
      setPage(1);
    }
  }, [initialTags, pageSize]);

  const onMoreClick = () => {
    setPage(prevPage => prevPage + 1);
  };

  return (
    <div className="tagList">
      {tagsList.map((tag, index) => (
        <TagLink tag={tag} key={`${tag.name}-${index}`} counts={counts} />
      ))}
      {tagsList.length !== tags.length && (
        <div className="moreBtn">
          <PinkBaseButton onClick={onMoreClick} type="button" aria-label="Load more tags button">
            <PlusIcon />
          </PinkBaseButton>
        </div>
      )}
    </div>
  );
});
